var _metadata, _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproveHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "27 27 104 105",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _metadata || (_metadata = /*#__PURE__*/React.createElement("metadata", {
    id: "metadata4530"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4528"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "currentColor",
    strokeWidth: 4.14937544,
    fillOpacity: 1,
    id: "path4533",
    cx: 79,
    cy: 79.106339,
    rx: 51.893661,
    ry: 52
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x30_02-success",
    transform: "translate(26.000000, 26.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fill: "currentColor",
    d: "M53,1C24.3,1,1,24.3,1,53s23.3,52,52,52s52-23.3,52-52S81.7,1,53,1z M53,101   C26.5,101,5,79.5,5,53S26.5,5,53,5s48,21.5,48,48S79.5,101,53,101z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fill: "#FFFFFF",
    d: "M77.5,31.7L46.8,66.3L28.2,51.4c-0.9-0.7-2.1-0.5-2.8,0.3c-0.7,0.9-0.5,2.1,0.3,2.8l20,16   c0.4,0.3,0.8,0.4,1.2,0.4c0.6,0,1.1-0.2,1.5-0.7l32-36c0.7-0.8,0.7-2.1-0.2-2.8C79.5,30.8,78.2,30.8,77.5,31.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveHistoryIcon);
export default __webpack_public_path__ + "static/media/ApproveHistoryIcon.8dd35f5f30f93280ecd755f9aa89e524.svg";
export { ForwardRef as ReactComponent };